module.exports = __webpack_public_path__ + "img/icon_tuijfangjian_home.24f5edda.png";